gsap.registerPlugin(ScrollTrigger);
//gsap.registerPlugin(toggleClass)
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

const ateliersAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      
      let introTitle = document.querySelector(".intro .section-title");
      let introText = document.querySelector(".intro .intro-text");

      let frame = document.querySelector(".workshop-frame");
      
      let expTitle = document.querySelector(".experiences .section-title");

      gsap.from(introTitle, {
        scrollTrigger: {
          
          trigger: introTitle,
          markers: false,
          start: 'top 75%',
          //scrub: true,
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        x:100,
      },)
      ;

      gsap.from(introText, {
        scrollTrigger: {
          
          trigger: introText,
          markers: false,
          start: 'top 75%',
          //scrub: true,
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        x:100,
      },)
      ;
      
      gsap.from(expTitle, {
        scrollTrigger: {
          
          trigger: expTitle,
          markers: false,
          start: 'top 75%',
          //scrub: true,
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        y:100,
      },)
      ;
  
      gsap.from(frame, {
        scrollTrigger: {
          
          trigger: frame,
          markers: false,
          start: 'top 75%',
          //scrub: true,
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        x:100,
      },)
      ;
  

    });
  },
};

export default ateliersAnim;
